
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ContractService } from '../../../../../services/contract.service';
import { NgForm, NgModel } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { Console } from '@angular/core/src/console';
import { Contract } from '../../../../../models/Contract';
import { Observable } from 'rxjs/Observable';
import { Registration } from '../../../../../models/Registration';
import { AddContract } from '../../../../../models/AddContract';
/*tslint:enable:max-line-length */
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';
import { DataService } from '../../../../../services/data.service';

@Component({
  selector: 'app-update-registration',
  templateUrl: './update-registration.component.html',
  styleUrls: ['./update-registration.component.scss']
})
export class UpdateRegistrationComponent implements OnDestroy, OnInit {
  _router: Router;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  oldRegistratonNumber: string;
  newRegistrationNumber: string;
  contractNumber: string;
  errorMsg: string;
  successMsg: string;
  selectedContract: any;
  registration: Registration;
  userType: Number;

  private alive = true;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private contractService: ContractService,
    private dataSvc: DataService) {
    this._router = router;
    this.userType = this.dataSvc.userDisplayInfo.UserTypeID;
  }

  ngOnInit() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.getOldRegistration();

  }

  getOldRegistration() {
    this.selectedContract = this.contractService.selectedContract;
    this.oldRegistratonNumber = this.selectedContract.Registration.trim();
    this.contractNumber = this.selectedContract.ContractNumber;
  }

  goToMyContract(event) {
    this.refreshContractList(this.contractNumber);
    if (this.userType === 5) {
      this._router.navigate(['/pages/client/searchcontracts']);
    } else {
      this._router.navigate(['/pages/client/my-contracts']);
    }
  }

  updateRegistration() {
    console.log('new registrationnumber', this.newRegistrationNumber);
    if (this.newRegistrationNumber === 'undefined' || !this.newRegistrationNumber
      || this.newRegistrationNumber.indexOf('-') === 0 || this.newRegistrationNumber.indexOf('_') === 0) {
      this.errorMsg = 'please enter correct registration number';
      console.log('errorMessage', this.errorMsg);
    } else {
      this.spinner.show();
      this.registration = new Registration();
      this.registration.ContractNumber = this.contractNumber;
      this.registration.NewRegistrationNum = this.newRegistrationNumber;
      this.registration.OldRegistrationNum = this.oldRegistratonNumber;
      this.contractService.UpdateRegistratonNumber(this.registration)
        .takeWhile(() => this.alive)
        .subscribe(
          data => {
            console.log(data);
            this.showSuccessConfirmation = true;
            this.showFailConfirmation = false;
            this.successMsg = data.Result;
            // Refresh all contracts and the selected contract
            this.refreshContractList(this.contractNumber);

            this.spinner.hide();
          },
          err => {
            this.showFailConfirmation = true;
            this.showSuccessConfirmation = false;
            this.errorMsg = err._body;
            console.log('err', err);
            this.spinner.hide();
          });
    }
  }

  refreshContractList(contractNumber: string) {
    this.contractService.getContractList()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log('User contracts reloaded successfully.');
        },
        err => {
          console.log('User contracts reloaded failed!');
        }
      );

    this.contractService.setSelectedContract(contractNumber).subscribe(data => {
      console.log('Reloaded selected contract.');
    });
  }

  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/contract/update-registration/update-registration.component.ts